import ThirdPartyOwnerVesselPostProcessingService from './ThirdPartyOwnerVesselPostProcessingService';

class DryCargoVesselPostProcessingService extends ThirdPartyOwnerVesselPostProcessingService {}

export default DryCargoVesselPostProcessingService;
